// extracted by mini-css-extract-plugin
export default {"Wrapper":"HeroHeader-Wrapper","Overlay":"HeroHeader-Overlay","Content":"HeroHeader-Content"};